import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Primary (canonical) domain for the site.
const PRIMARY_HOST = "salonsale.com.au";
const PRIMARY_ORIGIN = `https://${PRIMARY_HOST}`;

/**
 * Canonicalises the site to https://salonsale.com.au:
 *  - Redirects www -> apex and http -> https (ONLY when served on the custom
 *    domain, so preview/emergent.host URLs are never affected).
 *  - Keeps a <link rel="canonical"> in sync with the current route.
 */
export default function DomainCanonical() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    const { hostname, protocol } = window.location;
    const onCustomDomain = hostname === PRIMARY_HOST || hostname.endsWith(`.${PRIMARY_HOST}`);

    if (onCustomDomain) {
      const isWww = hostname.startsWith("www.");
      const needsHttps = protocol !== "https:";
      if (isWww || needsHttps) {
        window.location.replace(`${PRIMARY_ORIGIN}${pathname}${search}${hash}`);
        return;
      }
    }

    // Maintain a canonical tag (skip admin routes — they shouldn't be indexed).
    let link = document.querySelector('link[rel="canonical"]');
    if (pathname.startsWith("/admin")) {
      if (link) link.parentNode.removeChild(link);
      return;
    }
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    const path = pathname === "/" ? "" : pathname;
    link.setAttribute("href", `${PRIMARY_ORIGIN}${path}`);
  }, [pathname, search, hash]);

  return null;
}
